import moment from 'moment';

/**
 * Helper function to extract initial values from template fields
 * @param {Object} template - The store order template
 * @returns {Object} Map of field names to initial values
 */
export const getInitialValuesFromTemplate = (template) => {
  const initialValues = {};
  
  if (template && template.fields) {
    template.fields.forEach(field => {
      // Skip note fields as they don't have values
      if (field.type === 'note') return;
      
      // Add field to initialValues if it has an initialValue property
      if (field.hasOwnProperty('initialValue')) {
        initialValues[field.name] = field.initialValue;
      }
      // Special case: requestDate defaults to current date if not already set
      else if (field.name === 'requestDate') {
        initialValues[field.name] = moment().format('YYYY-MM-DD');
      }
    });
  }
  
  return initialValues;
};

